
import { Options, Vue } from 'vue-class-component';
import Popper from 'vue3-popper';
import { Course, CourseEnrollment } from "@/data/course";
import { CourseMode } from "@/data/enums";
import { Appointment } from "@/data/appointments";
// import CourseSpecialInfo from "@/components/CourseSpecialInfo.vue";
import CourseService from "@/services/CourseService";
import AppointmentsCalendar from "@/components/AppointmentsCalendar.vue";
import { formatDatetimeWithDayLabel } from "@/utils/helpers";

@Options({
    props: {
        course: {
            type: [Object, null],
            required: true,
        },
        /*courseEnrollment: {
            type: Object,
            required: true,
        },*/
        shown: {
            type: Boolean,
            required: true,
        }
    },
    components: {
        Popper,
        AppointmentsCalendar,
        // CourseSpecialInfo,
    },
    methods: {
        formatDatetimeWithDayLabel,
    },
    emits: [
        'close',
        'enrollmentStatusChange',
    ],
})
export default class CourseAppointmentsModal extends Vue {
    course!: Course|null
    // courseEnrollment!: CourseEnrollment

    shown!: boolean
    //showCoursesButton = false

    //regionStale = true

    appointments: Appointment[]|null = null

    loadingAppointments = false

    closeModal() {
        this.$emit('close');
    }

    onEnrollmentStatusChange() { // @TODO: make this work
        this.$emit('enrollmentStatusChange');
    }

    get description() {
        return /*this.course?.info_text ||*/ this.course?.course_type.description || null;
    }

    get descriptionLines() {
        if( !this.description ) {
            return [];
        }

        return this.description.split("\n");
    }

    get appointmentsWithCourse() {
        return this.appointments?.map(appointment => ({
            ...appointment,
            course: this.course,
        })) || [];
    }

    get appointmentsHintText() {
        if( this.appointments === null ) {
            return '';
        }
        return this.appointments.length + ' kommende Termine' + (this.appointments.length > 0 ? `, nächster Termin ${formatDatetimeWithDayLabel(this.appointments[0].start)}` : '');
    }

    loadAppointments(): void {
        if( !this.course ) {
            return;
        }

        if( this.course.mode !== CourseMode.Open ) {
            console.error('Can not show appointments because course is not open');
            return;
        }

        this.loadingAppointments = true;
        CourseService.getCourseAppointments(this.course.id).then(result => {
            this.appointments = result.data?.data;
        }).finally(() => this.loadingAppointments = false);
    }


    mounted() {
        this.$watch('shown', (newShown: boolean) => {
            if( newShown ) {
                //console.log(this.appointment);
                //this.loadEnrollmentState();
                console.log('tmp SHOW MODAL CourseEnrollmentModal');
                this.appointments = null;
                this.loadAppointments();
            }
        });

        /*
        this.$watch('course', () => {
            this.appointments = null;
            this.loadAppointments();
        }, {
            immediate: true
        });
        */
    }
}
